import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { intl } from '../../../../modules/Intl/IntlGlobalWrapper';
import {
  saveConfig,
  updateBreakdownField,
  updateEnabledColors,
  updateFieldColors,
  updateWipBreakdownBy
} from '../../FilterActions';
import { CustomSelect } from '../common';
import textUtils from '../../../../util/text';
import { hasLabels } from '../../../../util/customFieldsUtils';

class BreakdownByComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  static defaultProps = {
    inputName: 'breakdownBy'
  };

  componentDidMount() {
    this.updateState();
    this.props.updateFieldColors(this.props.breakdownBy, this.props.chart);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customFields != this.props.customFields) {
      this.updateState();
    }
  }

  updateState() {
    const items = _.map(this.props.customFields, cf => {
      return {
        label: cf.name,
        value: cf.extId
      };
    });

    const { app, dashboard } = this.props;
    // Use dashboard.application for correct provider detection in multi-provider tenants
    const effectiveApp = dashboard.application || app;
    const fileApp = (effectiveApp === 'file' && !dashboard.isCsv) && (dashboard.isAzure ? 'azure' : 'jira');

    if (!dashboard.isCsv) {
      if (hasLabels(effectiveApp, dashboard.selectedFields)) {
        items.unshift({
          label: textUtils.format(intl.formatMessage({ id: `${fileApp || effectiveApp}.label` }), '', true, false, 'capitalize'),
          value: 'labels'
        });
      }
      items.unshift({
        label: textUtils.format(intl.formatMessage({ id: `${fileApp || effectiveApp}.list` }), '', true, false, 'capitalize'),
        value: 'lists'
      });
    }

    this.setState({
      items
    });
  }

  handleChange = ev => {
    this.props.updateBreakdownField(ev, this.props.chart);
    this.props.updateEnabledColors(ev, this.props.chart);
    this.props.updateFieldColors(ev, this.props.chart);
    this.props.saveConfig();
  };

  render() {
    const { items } = this.state;
    const { inputName } = this.props;

    return (
      <CustomSelect
        name={inputName}
        title={'Breakdown by'}
        items={items}
        value={this.props.breakdownBy}
        onSelect={this.handleChange}
      />
    );
  }
}

// Standard BreakdownBy for blockers/throughput charts
const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateBreakdownField: (field, chart) => dispatch(updateBreakdownField(field, chart)),
    updateFieldColors: (field, chart) => dispatch(updateFieldColors(field, chart)),
    updateEnabledColors: (field, chart) => dispatch(updateEnabledColors(field, chart))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    customFields: state.app.data && state.app.data.customFields ? state.app.data.customFields : [],
    chart: state.filters.chart,
    breakdownBy: state.filters[state.filters.chart].breakdownBy,
    dashboard: state.dashboards.selected
  };
};

const BreakdownBy = connect(mapStateToProps, mapDispatchToProps)(BreakdownByComponent);

// WIP Breakdown variant - same UI, different state key
const mapDispatchToPropsWip = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateBreakdownField: (field, chart) => dispatch(updateWipBreakdownBy(field, chart)),
    updateFieldColors: () => {},
    updateEnabledColors: () => {}
  };
};

const mapStateToPropsWip = state => {
  return {
    app: state.app.app,
    customFields: state.app.data && state.app.data.customFields ? state.app.data.customFields : [],
    chart: state.filters.chart,
    breakdownBy: state.filters[state.filters.chart].wipBreakdownBy || 'lists',
    dashboard: state.dashboards.selected,
    inputName: 'wipBreakdownBy'
  };
};

const WipBreakdownBy = connect(mapStateToPropsWip, mapDispatchToPropsWip)(BreakdownByComponent);

export { BreakdownBy, WipBreakdownBy };
